import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';

import { Box, Grid, Container } from '@mui/material';
import i18n from 'i18n-js';
import Can from 'components/Can';
import Title from 'components/Title';
import Layout from 'components/Layout';
import Comments from 'components/Comments';
import * as Components from './RelatedComponents';
import { useParams } from 'react-router-dom';
import { TasksDetails, TasksLogs } from 'components/Tasks';
import DocumentsWidget from 'components/Documents/Widget';

const UserDetails = () => {
  const { id } = useParams();

  const { current } = useSelector((state) => state.tasks || {});

  const instance = () => {
    const { task_source_name, task_source_id } = current;
    const Component = Components[task_source_name] ?? '';
    if (!Component) return;
    return <Component key={1} id={task_source_id} related="task" />;
  };

  return (
    <Layout title={i18n.t('tasks.single') + ` - T${id}`}>
      <Container maxWidth={false} disableGutters>
        <Box sx={{ mb: 2.5 }}>
          <Title title={i18n.t('tasks.single') + ` - T${id}`} />
        </Box>
        {/* <Grid container>
          <Grid size={{ xs: 12 }}> */}
        <Grid container spacing={2} sx={{ m: 0, width: '100%' }}>
          <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4 }}>
            <Grid container spacing={2} sx={{ m: 0, width: '100%' }}>
              <Grid size={{ xs: 12 }}>
                <TasksDetails id={id} />
              </Grid>
              {current?.task_source_name && (
                <Grid size={{ xs: 12 }}>
                  <Can I="read" on="event_log">
                    <TasksLogs id={parseInt(id)} />
                  </Can>
                </Grid>
              )}
            </Grid>
          </Grid>
          {current?.task_source_name ? (
            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4 }}>
              <Grid container spacing={2} sx={{ m: 0, width: '100%' }}>
                <Grid size={{ xs: 12 }}>
                  {current?.task_source_name && (
                    <Suspense fallback={<div>Loading...</div>}>{instance()}</Suspense>
                  )}
                </Grid>
                <Can I="read" a="document">
                  <Grid size={{ xs: 12 }}>
                    <DocumentsWidget type="Task" id={parseInt(id)} />
                  </Grid>
                </Can>
              </Grid>
            </Grid>
          ) : (
            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4 }}>
              <Can I="read" on="event_log">
                <TasksLogs id={parseInt(id)} />
              </Can>
            </Grid>
          )}
          <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4 }}>
            <Grid container spacing={2} sx={{ m: 0, width: '100%' }}>
              <Grid size={{ xs: 12 }}>
                <Can I="read" a="comment">
                  <Comments type="task" id={parseInt(id)} />
                </Can>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* </Grid>
        </Grid> */}
      </Container>
    </Layout>
  );
};

export default UserDetails;
